/**
 * ViewToggle — Grid/List view toggle control.
 */
import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface ViewToggleProps {
  view: 'grid' | 'list';
  onViewChange: (view: 'grid' | 'list') => void;
  className?: string;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange, className }) => (
  <div className={cn("flex items-center bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-800 p-1", className)}>
    {(['grid', 'list'] as const).map((v) => (
      <button
        key={v}
        onClick={() => onViewChange(v)}
        className={cn(
          "px-2 h-8 rounded-md flex items-center justify-center transition-colors",
          view === v
            ? 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white'
            : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
        )}
      >
        {v === 'grid' ? <LayoutGrid className="w-4 h-4" /> : <List className="w-4 h-4" />}
      </button>
    ))}
  </div>
);
export default ViewToggle;
